import React, { useEffect, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import _ from 'lodash'
import { FormGroup } from 'reactstrap'

import { dateToGoogle } from '~/utility/date'
import { Show } from '~/components/commons'
import EditableRow from '~/components/EditableRow'
import DateTimePicker from '~/components/DateTimePicker'
import SpecialHoursRangeInput from './SpecialHoursRangeInput'

function SpecialHoursField({
  name,
  controller,
  label,
  editableFields,
  onSwitchChange,
}) {
  const switchId = `${name}Switch`
  const [datePickerInput, setDatePickerInput] = useState([])
  const dates = useMemo(() => {
    return _.get(controller.values, name)
  }, [controller.values, name])

  useEffect(() => {
    setDates(prevDates =>
      datePickerInput.reduce((acc, date) => {
        const dateObj = dateToGoogle(date)

        const foundDayIdx = prevDates.findIndex(({ startDate }) =>
          _.isEqual(startDate, dateObj)
        )

        if (foundDayIdx >= 0) {
          acc.push(prevDates[foundDayIdx])
          acc.push(prevDates[foundDayIdx + 1])
        } else {
          acc.push({
            startDate: dateObj,
            endDate: dateObj,
            openTime: {
              hours: 9,
              minutes: 0,
              seconds: 0,
              nanos: 0,
            },
            closeTime: {
              hours: 18,
              minutes: 0,
              seconds: 0,
              nanos: 0,
            },
            closed: false,
          })
          acc.push({
            startDate: dateObj,
            endDate: dateObj,
          })
        }
        return acc
      }, [])
    )

    // eslint-disable-next-line
  }, [datePickerInput])

  function handleDateChange(id, value) {
    setDates(curr => {
      const newArr = [...curr]
      newArr[id] = value
      return newArr
    })
  }

  function setDates(value) {
    controller.setFieldValue(name, _.isFunction(value) ? value(dates) : value)
  }

  return (
    <>
      <EditableRow
        switchId={switchId}
        onChange={id => {
          if (editableFields?.[switchId]) {
            setDatePickerInput([])
          }
          onSwitchChange(id)
        }}
        isChecked={!!editableFields?.[switchId]}
      >
        <FormGroup>
          <label htmlFor={name}>
            <FormattedMessage id={label} />:
          </label>
          <DateTimePicker
            value={datePickerInput}
            onChange={setDatePickerInput}
            options={{
              mode: 'multiple',
              minDate: 'today',
            }}
            disabled={!editableFields?.[switchId]}
          />
        </FormGroup>
      </EditableRow>
      <Show condition={!!dates}>
        <OpenRangeInputsWrapper>
          {dates?.map(
            (day, i) =>
              i % 2 === 0 && (
                <SpecialHoursRangeInput
                  id={i}
                  key={i}
                  defaultTimeState={[
                    dates?.[i],
                    value => handleDateChange(i, value),
                  ]}
                  aditionalTimeState={[
                    dates?.[i + 1],
                    value => handleDateChange(i + 1, value),
                  ]}
                  day={day}
                />
              )
          )}
        </OpenRangeInputsWrapper>
      </Show>
    </>
  )
}

const OpenRangeInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export default React.memo(SpecialHoursField)
